/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import clsx from 'clsx';
import React from 'react';
import { OverlayProps, overlayPropsDefaults } from './Overlay.props';

/**
 * SDS Overlay component.
 */
export const Overlay = (props: OverlayProps): JSX.Element => {
  const { fullScreen } = { ...overlayPropsDefaults, ...props };
  const overlayClass = clsx(`sds-overlay`, { [`overlay--fullscreen`]: fullScreen });

  return <div className={overlayClass} />;
};
